import {
    BrowserConsoleAppender,
    getLoggerFactory,
    HttpAppender,
    LoggerNameWithMessageLayout,
    LoggingLevel,
    Logger,
} from 'alfa-web-tools/lib';
import { Appender } from 'alfa-web-tools/lib/logger/Appender';

import AxiosHttpClient from 'app/api/AxiosHttpClient';

export const DEFAULT_LOGGER_NAME = 'by.alfabank.web.cc';
export const LOGGER_BACKEND_URL = '/logs';

const getLogger = (name: string): Logger => {
    const apiClient = new AxiosHttpClient();
    const isUseConsoleAppender =
        window.location.href.match(/dev|tst|localhost/g)?.length > 0;

    const appenders: Appender[] = [
        new HttpAppender(
            (...params) => apiClient.executeLoggerRequest(...params),
            LOGGER_BACKEND_URL,
        ),
    ];

    if (isUseConsoleAppender) {
        appenders.push(
            new BrowserConsoleAppender(new LoggerNameWithMessageLayout()),
        );
    }
    const factory = getLoggerFactory({
        configs: [
            {
                appenders,
                pattern: new RegExp('.'),
                level: LoggingLevel.INFO,
            },
        ],
    });

    return factory(name);
};

/**
 * Регистрация функции получения логгера во всем приложении глобально.
 */
export const appendLogger = (): void => {
    (window as any).getLogger = (name: string = DEFAULT_LOGGER_NAME) => {
        return getLogger(name);
    };
};
